import React, { Suspense, lazy } from 'react';
import { Header } from './components/ToxicDetector/Header';
import { HeroSection } from './components/ToxicDetector/HeroSection';
import { TrustSection } from './components/ToxicDetector/TrustSection';
import { Footer } from './components/ToxicDetector/Footer';
import { MetaTags } from './components/SEO/MetaTags';
import { ProStatusListener } from './components/ProStatusListener';
import { LazySection } from './components/LazySection';
// Lazy-load every below-the-fold section. Each gets its own
// LazySection wrapper which adds IntersectionObserver + its own Suspense
// boundary, so chunks are only requested as the user scrolls near them.
const SocialProofSection = lazy(() => import('./components/ToxicDetector/SocialProofSection').then(m => ({
  default: m.SocialProofSection
})));
const CredentialsImageSection = lazy(() => import('./components/ToxicDetector/CredentialsImageSection').then(m => ({
  default: m.CredentialsImageSection
})));
const HiddenToxicitySection = lazy(() => import('./components/ToxicDetector/HiddenToxicitySection').then(m => ({
  default: m.HiddenToxicitySection
})));
const DetectionImageSection = lazy(() => import('./components/ToxicDetector/DetectionImageSection').then(m => ({
  default: m.DetectionImageSection
})));
const ToxicityAuditSection = lazy(() => import('./components/ToxicDetector/ToxicityAuditSection').then(m => ({
  default: m.ToxicityAuditSection
})));
const WarningImageSection = lazy(() => import('./components/ToxicDetector/WarningImageSection').then(m => ({
  default: m.WarningImageSection
})));
const FeaturesSection = lazy(() => import('./components/ToxicDetector/FeaturesSection').then(m => ({
  default: m.FeaturesSection
})));
const ShareYourStorySection = lazy(() => import('./components/ToxicDetector/ShareYourStorySection').then(m => ({
  default: m.ShareYourStorySection
})));
const GuaranteesSection = lazy(() => import('./components/ToxicDetector/GuaranteesSection').then(m => ({
  default: m.GuaranteesSection
})));
const IntroImageSection = lazy(() => import('./components/ToxicDetector/IntroImageSection').then(m => ({
  default: m.IntroImageSection
})));
const ToolsSection = lazy(() => import('./components/ToxicDetector/ToolsSection').then(m => ({
  default: m.ToolsSection
})));
const ComparisonSection = lazy(() => import('./components/ToxicDetector/ComparisonSection').then(m => ({
  default: m.ComparisonSection
})));
const PricingSection = lazy(() => import('./components/ToxicDetector/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQSection = lazy(() => import('./components/ToxicDetector/FAQSection').then(m => ({
  default: m.FAQSection
})));
const JourneyImageSection = lazy(() => import('./components/ToxicDetector/JourneyImageSection').then(m => ({
  default: m.JourneyImageSection
})));
const CTASection = lazy(() => import('./components/ToxicDetector/CTASection').then(m => ({
  default: m.CTASection
})));
const SEONavigationSection = lazy(() => import('./components/ToxicDetector/SEONavigationSection').then(m => ({
  default: m.SEONavigationSection
})));
// Lazy-load non-critical UI that appears after user interaction or scroll
const PromoBanner = lazy(() => import('./components/Notifications/PromoBanner').then(m => ({
  default: m.PromoBanner
})));
const FloatingActionBar = lazy(() => import('./components/ToxicDetector/FloatingActionBar').then(m => ({
  default: m.FloatingActionBar
})));
export function App() {
  return <>
      <ProStatusListener data-id="element-19" data-mp="1i5x7gukplcnq" />
      <MetaTags data-id="element-20" data-mp="1m4mulevju8kk" />
      <Suspense fallback={null} data-id="element-21" data-mp="1m44rbyagyu35">
        <PromoBanner data-id="element-22" data-mp="1m3cwipop50dx" />
      </Suspense>
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-23" data-mp="6onpydl54up2">
        <Header data-id="element-24" data-mp="apr9ba2ed8v1" />
        <main data-id="element-25" data-mp="aq99ghs6k788">
          {/* Above the fold — eager loaded so first paint is instant. */}
          <HeroSection data-id="element-26" data-mp="qxnifbnxjwqb" />
          <TrustSection data-id="element-27" data-mp="qxxbj849uk08" />

          {/* Below the fold — each section streams in independently
           via IntersectionObserver + its own Suspense boundary. */}
          <LazySection minHeight={520} data-id="element-28" data-mp="h6syidy5p981">
            <SocialProofSection data-id="element-29" data-mp="h7vnggbx51lb" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-30" data-mp="c8rg7v8k1dxm">
            <CredentialsImageSection data-id="element-31" data-mp="c9u55xmbh6aw" />
          </LazySection>
          <LazySection minHeight={600} data-id="element-32" data-mp="19wjd0o3pad4o">
            <HiddenToxicitySection data-id="element-33" data-mp="19vhslt0soeaa" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-34" data-mp="14wetep7hx2a8">
            <DetectionImageSection data-id="element-35" data-mp="14xpzwwsbso51" />
          </LazySection>
          <LazySection minHeight={600} data-id="element-36" data-mp="zx2b8hrkkjdz">
            <ToxicityAuditSection data-id="element-37" data-mp="zw0npdtda4fd" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-38" data-mp="vx07m329xfw2">
            <WarningImageSection data-id="element-39" data-mp="vvywjyl9ctec" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-40" data-mp="3kob40eqgi45a">
            <FeaturesSection data-id="element-41" data-mp="3kpdw2pzimcms" />
          </LazySection>
          <LazySection minHeight={620} data-id="element-42" data-mp="3gm7rrnvyqviy">
            <ShareYourStorySection data-id="element-43" data-mp="3gl62ofi448i8" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-44" data-mp="1w58292a78wun">
            <GuaranteesSection data-id="element-45" data-mp="1w69o81sr73r5" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-46" data-mp="2058rlhyu6sgh">
            <IntroImageSection data-id="element-47" data-mp="206a13i07f6w3" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-48" data-mp="254v2vlv3tymn">
            <ToolsSection data-id="element-49" data-mp="253sfhnwzqebh" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-50" data-mp="29wd7cjwc6hcd">
            <ComparisonSection data-id="element-51" data-mp="29xejyst03bw7" />
          </LazySection>
          <LazySection minHeight={700} data-id="element-52" data-mp="2evg1386v9151">
            <PricingSection data-id="element-53" data-mp="2euelcqewnqgz" />
          </LazySection>
          <LazySection minHeight={600} data-id="element-54" data-mp="2jthtijq6mct6">
            <FAQSection data-id="element-55" data-mp="2jsg4fbcbzpsg" />
          </LazySection>
          <LazySection minHeight={420} data-id="element-56" data-mp="2nvums8nqsi92">
            <JourneyImageSection data-id="element-57" data-mp="2nww8r86aqp5k" />
          </LazySection>
          <LazySection minHeight={500} data-id="element-58" data-mp="2sufm85v66xwg">
            <CTASection data-id="element-59" data-mp="2steeaa9gariy" />
          </LazySection>
          <LazySection minHeight={300} data-id="element-60" data-mp="thlde2jjl20y">
            <SEONavigationSection data-id="element-61" data-mp="timw8t6sust8" />
          </LazySection>
        </main>
        <Footer data-id="element-62" data-mp="yg4xryihm5r7" />
      </div>
      <Suspense fallback={null} data-id="element-63" data-mp="yhg15x80tbhs">
        <FloatingActionBar data-id="element-64" data-mp="yir7a3oxuvc2" />
      </Suspense>
    </>;
}